import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <main
      data-testid="not-found-page"
      className="dark-section bg-slate-950 text-white min-h-screen flex items-center justify-center px-5"
    >
      <div className="max-w-2xl text-center">
        <span className="label-eyebrow text-cyan-300">Error 404</span>
        <h1 className="mt-4 font-heading font-black text-6xl md:text-8xl leading-[0.9] tracking-tighter">
          Wrong <span className="text-accent-blue italic">turn.</span>
        </h1>
        <p className="mt-6 text-lg text-white/70 leading-relaxed">
          The page you&apos;re after isn&apos;t here. Head back to base and
          find your way from there.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-full bg-accent-blue text-white font-heading font-semibold text-sm hover:bg-cyan-500 transition-colors"
          >
            Back to home <ArrowUpRight size={16} />
          </Link>
          <Link
            to="/what-we-do"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-white/25 text-white font-heading font-semibold text-sm hover:border-accent-blue hover:bg-white/5 transition-colors"
          >
            See what we do <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </main>
  );
}
